import { render, staticRenderFns } from "./UserPanels.vue?vue&type=template&id=5a868a0c"
import script from "./UserPanels.vue?vue&type=script&lang=js"
export * from "./UserPanels.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports